import React, { useEffect, useState } from 'react';
import EIF from './EIF';
import LoaderComponent from './LoaderComponent';
import FileUpload from '../Common/FileUpload';
import { fetchEiflist, fetchQuestionsCategory, TriggerIPFEmail } from '../api/api';
import Modal from 'react-modal';
import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dropzone from 'react-dropzone';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

function IpfConfigure(props) {
    const [isOpen, setOpenModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [eifData, setEifData] = useState([]);
    const [rafData, setRafData] = useState([]);
    const [selectedOrg, setSelectOrg] = useState('');
    const [selectedRAF, setSelectRAF] = useState('');
    const [selectedOrgDetails, setSelectOrgDetails] = useState([]);
    const [attachmentList, setAttachmentList] = useState([]);
    const [error, setError] = useState('');


    useEffect(() => {
        onLoadData();
    }, [])

    const handleClear = async () => {
        await onLoadData();
        setRafData([]);
        setSelectOrg('');
        setAttachmentList([]);
        setOpenModal(false);
        setSelectOrgDetails([]);
    };

    const onLoadData = async () => {
        setLoading(true);
        let EifList = await fetchEiflist();

        EifList = EifList?.response?.length > 0 ? EifList?.response : [];
        EifList.push({ org_name: '+ Add new Organization', id: null })

        setEifData(EifList);
        setLoading(false);
        return EifList;
    }

    const handleOrgSelect = async (e) => {
        let { name, value } = e.target;
        setSelectOrg(value);
        setSelectRAF('');
        setAttachmentList([]);
        if (value === "+ Add new Organization") {
            setOpenModal(true);
            setSelectOrgDetails([]);
            setRafData([]);
        } else {
            setLoading(true);

            let EifRecord = eifData.find((item) => item.customer_id == value)?.questions;
            setSelectOrgDetails(EifRecord);
            let RafList = await fetchQuestionsCategory();
            RafList = RafList?.response?.length > 0 ? RafList?.response.filter((data) => (data.title !== "Express Interest")) : [];
            setRafData(RafList);
            setLoading(false);

        }
    }

    const handleRAFSelect = async (e) => {
        let { name, value } = e.target;
        setAttachmentList([]);
        setSelectRAF(value);
    }

    const onSubmitEifDetails = async () => {
        setOpenModal(false);
        let message = "Customer details saved successfully.";
        toast.info(message, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
        let latestRecords = await onLoadData();
        let EifRecord = latestRecords[0].questions;
        let customerId = latestRecords[0].customer_id;
        setSelectOrg(customerId);
        setSelectOrgDetails(EifRecord);
        let RafList = await fetchQuestionsCategory();
        RafList = RafList?.response?.length > 0 ? RafList?.response.filter((data) => (data.title !== "Express Interest")) : [];
        setRafData(RafList);
        setLoading(false);
    }
    const sendEmail = async (e) => {
        const data = {
            customer: selectedOrg,
            category: 1,
            ipf_category: selectedRAF,
            form_status: 'approved'
        }
        let formdata = new FormData();
        Object.keys(data).forEach((item) =>
            formdata.append(item, data[item]));

        attachmentList.forEach((file) => {
            formdata.append("attachments", file)
        })
        setLoading(true);
        try {
            const response = await TriggerIPFEmail(formdata);

            if (response.status === 'failed') {
                setError(response.message);
                toast.error(`${response?.message}`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
            } else {
                toast.info(`Email sent successfully.`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
                window.location.reload();
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.error(e);
            return;
        }
    }
    
    return (
        <div className="cotainer m-4">
            <div className="row p-2 m-2 bg-primary text-white d-flex justify-content-center">IPF Configured Forms - Organizations</div>
            <LoaderComponent isLoading={isLoading} />
            <div className="card rounded shadow-sm p-4 m-2" style={{backgroundColor:"#F5F5F5"}}>
                <div className="row"><h6 className='p-1' style={{ color: "#8284e5" }}>Select appropriate IPF to selected Organization along with necessary attachments if needed to send Email:</h6></div>
                <div className='m-2'>
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <span className="text-primary font-weight-bold">
                                <label className='text-danger'>*</label> Select Organization:
                                {!selectedOrg && (<small className='text-danger'>&nbsp;required</small>)}
                            </span>
                            <select name="selectedOrg" value={selectedOrg} className="form-control" id="FormControlSelect1"
                                required onChange={(e) => handleOrgSelect(e)}
                            >
                                <option value="">Select Organization</option>
                                {eifData.map((data, i) => !data.is_approved && (
                                    <option key={i} value={data.customer_id}
                                        selected={data.customer_id === selectedOrg}
                                    >
                                        {data.org_name}
                                    </option>
                                ))}
                            </select>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            {rafData.length > 0 && (
                                <div>
                                    <span className="text-primary font-weight-bold">
                                        <label className='text-danger'>*</label> Assign IPF:
                                        {!selectedRAF && (<small className='text-danger'>&nbsp;required</small>)}
                                    </span>
                                    <select name="eif_org" className="form-control" id="FormControlSelect1"
                                        required onChange={(e) => handleRAFSelect(e)}
                                    >
                                        <option value="">Select RAF</option>
                                        {rafData.map((data, i) => (
                                            <option key={i} value={data.id}
                                                selected={data.id === selectedOrg}
                                            >
                                                {data.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </Grid>

                    </Grid>
                </div>
                <br />
                {selectedOrgDetails.length > 0 && (
                    <React.Fragment>
                        <div className="form-group row mt-3 mb-3">
                            <div className="col-sm-6">
                                <ul className="list-group">
                                    {selectedOrgDetails.map(qinfo => (qinfo.answers.map(q =>
                                    (
                                        <li className="list-group-item mb-1" >
                                            <span className="text-primary "> {qinfo.question}</span> <br />
                                            <span className=" ">(A)</span> - <span className="text-primary font-weight-bold">{q.answer}</span>
                                        </li>))))}
                                </ul>
                            </div>
                            <div className="col-sm-6">
                                <FileUpload setFiles={setAttachmentList} files={attachmentList} />
                            </div>
                        </div>

                        <div className="form-group row mt-3 mb-3">
                            <div className="col-sm-1  ">
                                &nbsp;
                            </div>
                            <div className="col-sm-5 d-flex justify-content-center">

                                <button type="submit" value="approved" className="btn btn-primary pr-5 pl-5" disabled={!selectedRAF} onClick={e => sendEmail(e, "value")}>Send Email</button>
                            </div>
                            <div className="col-sm-5 d-flex justify-content-center">
                                <button type="submit" value="rejected" className="btn btn-secondary pr-5 pl-5" onClick={() => handleClear()}>Clear</button>
                            </div>
                            <div className="col-sm-1">
                                &nbsp;
                            </div>
                        </div>

                    </React.Fragment>
                )}

                <Modal
                    isOpen={isOpen}
                    //onRequestClose={() => setOpenModal(false)}
                    style={customStyles}
                    contentLabel="Forgot Password"
                    ariaHideApp={false}
                    shouldCloseOnEsc={true}
                >
                    <button onClick={() => handleClear()} style={{ float: 'right', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>×</button>
                    <EIF
                        onSubmitEifDetails={onSubmitEifDetails}
                        isFromIPF={true} />
                </Modal>
            </div>
        </div>


    )
}

export default IpfConfigure;